module.exports = __webpack_public_path__ + "img/heiltherme_steiermark_logo_d52f165e.77b232ca.svg";